skrilla.directive('userAccounts', function () {
    return {
        templateUrl: 'directives/userAccounts/userAccounts.html',
        scope: {
            user: "="
        },
        controller: function ($scope, modalService, cacheService, searchService, currencyService, srefService, adminService) {
            $scope.hasRole = adminService.hasRole
            $scope.currencies = currencyService.getCurrencies();
            $scope.query = {currency: $scope.user.fiatCurrency};

            $scope.accountBalance = function (purpose) {
                let account = $scope.getAccount($scope.accounts, purpose)
                if (account) {
                    return account.currentBalance
                } else {
                    return 0
                }
            };

            $scope.openQueryUsers = function () {
                $scope.transferFundsBtn = !$scope.transferFundsBtn
            }

            $scope.getUserSettings = function () {
                searchService.get(`users/${$scope.user.id}/settings`).then(function (response) {
                    $scope.userSettings = response.data;
                    $scope.allowCancelWithdrawal = $scope.userSettings?.allowCancelWithdrawal ?? true;
                });
            }
            $scope.getUserSettings();

            $scope.updateUserSettings = function () {
                let action = $scope.allowCancelWithdrawal ? 'DISABLE' : 'ENABLE'
                let request = {
                    allowCancelWithdrawal: !$scope.allowCancelWithdrawal
                }
                modalService.confirm(`Are you sure you'd like to ${action} cancelling withdrawals for this user?`, function () {
                    searchService.put(`users/${$scope.user.id}/settings`, request, "Success", true).then(function (response) {
                        modalService.dismissAll();
                        $scope.userSettings = response.data
                        $scope.allowCancelWithdrawal = $scope.userSettings.allowCancelWithdrawal
                    })
                })
            }

            $scope.search = function() {
                searchService.get("users/" + $scope.user.id + "/accounts?currency=" + $scope.query.currency).then(function (response) {
                    $scope.currency = $scope.query.currency;
                    $scope.accounts = response.data;
                    $scope.promotionBalance = $scope.accountBalance('PROMOTION_USER');
                    $scope.availableBalance = $scope.accountBalance('AVAILABLE');
                    searchService.get("users/" + $scope.user.id + "/lifetimeRevenue?currency=" + $scope.currency).then(function (lifetimeRevenueResponse) {
                        $scope.lifetimeRevenue = lifetimeRevenueResponse.data
                    })
                });
            }
            $scope.search();

            $scope.searchWithdrawalSettings = function() {
                searchService.get("users/" + $scope.user.id + "/withdrawalSettings").then(function (response) {
                    $scope.withdrawalSettings = response.data;
                });
            }
            $scope.searchWithdrawalSettings();

            $scope.deposit = function(){
                cacheService.registerObject("userDepositAccounts", $scope.accounts);
                modalService.openModal("views/createUserDepositModal/createUserDepositModal.html", true, 'lg', true, true, function(){
                    $scope.query.currency = $scope.accounts[0].currency;
                    $scope.search();
                });
            }
            $scope.promotionTransaction = function(type){
                var newDepositPromotion = {
                    currency: $scope.accounts[0].currency,
                    userId: $scope.user.id,
                    type: type
                };
                cacheService.registerObject("newPromotionTransaction", newDepositPromotion);
                modalService.openModal("views/createUserPromotionalTransaction/createUserPromotionalTransactionModal.html", true, 'lg', true, true, function(){
                    $scope.query.currency = $scope.accounts[0].currency;
                    $scope.search();
                });
            }

            $scope.showDeposits = function () {
                srefService.go("deposits", {userId: $scope.user.id});
            }
            $scope.showWithdrawals = function () {
                srefService.go("withdrawals", {userId: $scope.user.id});
            }
            $scope.withdraw = function(){
                cacheService.registerObject("account", $scope.getAccount($scope.accounts,'AVAILABLE'));
                searchService.get("users/" + $scope.user.id + "/externalWallets").then(function(response) {
                    $scope.wallets = response.data;
                    cacheService.registerObject("bankAccounts", $scope.wallets.bankAccounts);
                    modalService.openModal("views/withdrawals/createAudBankWithdrawalModal.html", true, 'lg', true, true);
                });
            }

            $scope.transferAvailableFunds = function () {
                cacheService.registerObject("fromUser", $scope.user)
                cacheService.registerObject("fromUserAvailableAccount", $scope.getAccount($scope.accounts, 'AVAILABLE'))
                modalService.openModal("views/userFundsTransfers/transferAvailableFundsModal.html", true, 'lg', true, true, function () {
                    $scope.search()
                })
            }

            $scope.getAccount = function(accounts, purpose){
                return accounts.filter(function(account){ return account.purpose === purpose })[0];
            }
            $scope.manualTurnover = function(settings){
                cacheService.registerObject("manualTurnoverRequest", {
                    amount: currencyService.divide(settings.amountToTurnover, settings.currency),
                    currency: settings.currency,
                    user: $scope.user
                });
                modalService.openModal("views/createManualUserTurnoverModal/createManualUserTurnoverModal.html", true, 'lg', true, true, function(){
                    $scope.searchWithdrawalSettings();
                });
            }

            $scope.createChargeBack = function(){
                cacheService.registerObject("user", $scope.user)
                modalService.openModal("views/chargebacks/createChargeback.html", true, 'lg', true, true, function(){

                });
            }

        }
    };
});
